import { useEffect, useRef } from "react";

import { Button } from "@/components/ui/Button";
import { fireLevelUpConfetti } from "@/utils/celebrations";
import type { Level } from "@/utils/levels";

interface LevelUpModalProps {
  level: Level;
  onDismiss: () => void;
}

export function LevelUpModal({ level, onDismiss }: LevelUpModalProps) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    fireLevelUpConfetti();
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="animate-level-up-glow mx-4 w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-xl">
        <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-amber-100 text-3xl font-black text-amber-600">
          {level.level}
        </div>
        <h2 className="mb-1 text-2xl font-black text-gray-900">Level Up!</h2>
        <p className="mb-6 text-lg font-bold text-amber-600">{level.title}</p>
        <Button onClick={onDismiss} className="w-full" size="lg">
          Keep Playing
        </Button>
      </div>
    </div>
  );
}
